"use strict";

var domReady = function (n) {
  function e(e) {
    for (m = 1; e = i.shift();) {
      e();
    }
  }

  var _t2,
      i = [],
      r = document,
      o = r.documentElement,
      a = o.doScroll,
      s = "DOMContentLoaded",
      c = "addEventListener",
      d = "onreadystatechange",
      u = "readyState",
      m = (a ? /^loaded|^c/ : /^loaded|c/).test(r[u]);

  return r[c] && r[c](s, _t2 = function t() {
    r.removeEventListener(s, _t2, !1), e();
  }, !1), a && r.attachEvent(d, _t2 = function _t() {
    /^c/.test(r[u]) && (r.detachEvent(d, _t2), e());
  }), n = a ? function (t) {
    self != top ? m ? t() : i.push(t) : function () {
      try {
        o.doScroll("left");
      } catch (e) {
        return setTimeout(function () {
          n(t);
        }, 50);
      }

      t();
    }();
  } : function (e) {
    m ? e() : i.push(e);
  };
}(),
    xdm = {},
    xdm_1 = xdm = {
  timestamp: new Date().getTime(),
  ready: !1,
  logging: !0,
  messageHandlers: {},
  init: function init() {
    window.addEventListener ? window.addEventListener("message", xdm.onMessage) : window.attachEvent && window.attachEvent("onmessage", xdm.onMessage), xdm.ready = !0, xdm.onReady && xdm.onReady instanceof Function && xdm.onReady();
  },
  onMessage: function onMessage(e) {
    var t = e.data;
    t && t.channelName && xdm.messageHandlers[t.channelName] && xdm.messageHandlers[t.channelName](t);
  },
  createChannel: function createChannel(t) {
    var e = "_truexdm_" + new Date().getTime();
    return xdm.messageHandlers[e] = function (e) {
      t(e.message, e.payload);
    }, "&truexdm_channel=" + e;
  }
},
    uniqueIdentifier = function uniqueIdentifier() {
  return +new Date() + "_" + Math.floor(1e3 * Math.random());
},
    noOp = function noOp() {},
    getLocationProtocol = function getLocationProtocol() {
  var e = window.location.protocol || document.location.protocol;
  return "http:" !== e && (e = "https:"), e;
},
    client = function client(c, e) {
  var o,
      d = "get.truex.com",
      r = {},
      u = {},
      m = !0 === c.handle_clickthrough_manually;
  r.requestActivity = function (t) {
    c.max_activities = c.max_activities || "1", r.requestActivities(function (e) {
      t(e[0]);
    });
  }, r.requestActivities = function (i) {
    c.max_activities = c.max_activities || "0";
    var t = !1;
    n(), truex.loadExelateSegments(function () {
      if (p && !t) {
        t = !0;
        var e = x(c),
            n = new XMLHttpRequest();
        n.open("POST", e.substring(0, e.indexOf("?")), !0), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), n.onreadystatechange = function () {
          if (4 == n.readyState) {
            if (200 == n.status) {
              var e = JSON.parse(n.responseText);

              if (e && !e.error && Array.isArray(e) && 0 < e.length) {
                e[0].partner_id && (a(e[0].partner_id), _(e[0].partner_id), g(e[0].partner_id), h(e[0].partner_id));

                for (var t = 0; t < e.length; t++) {
                  r.prepareActivity(e[t]);
                }

                return void i(e);
              }
            }

            return y(), void i([]);
          }
        }, n.send(e.substr(e.indexOf("?") + 1));
      }
    });
  }, r.openActivityWindow = function (n) {
    var e = n && n.id ? "location=no,menubar=no,status=no,toolbar=no,width=" + n.window_width + ", height=" + n.window_height : "",
        t = truex.xdm.createChannel(function (e, t) {
      switch (e) {
        case "credit":
          u[n].credit(t);
          break;

        case "partialCredit":
          u[n].partialCredit(t);
          break;

        case "start":
          u[n].start(n);
          break;

        case "message":
          u[n].message(t);
          break;

        case "finish":
          u[n].finish(n);
          break;

        case "close":
          break;

        case "open":
          if (!m) break;
          u[n].clickthrough(t);
          break;

        case "error":
          u[n].error(n);
      }
    }),
        i = m ? "&iframed.mraid=1" : "";
    o = window.open(n.window_url + t + i, "truex_client_activity_window", e);
    var r = setInterval(function () {
      o.closed && (clearInterval(r), u[n].close(n));
    }, 500);
  }, r.loadActivityIntoContainer = function (n, e, t) {
    var i = t && void 0 !== t.width ? t.width : n.window_width,
        r = t && void 0 !== t.height ? t.height : n.window_height,
        o = t ? t.minWidth : void 0,
        a = t ? t.minHeight : void 0;
    i += isNaN(Number(i)) ? "" : "px", r += isNaN(Number(r)) ? "" : "px";
    var s = truex.xdm.createChannel(function (e, t) {
      switch (e) {
        case "credit":
          u[n].credit(t);
          break;

        case "partialCredit":
          u[n].partialCredit(t);
          break;

        case "start":
          u[n].start(n);
          break;

        case "message":
          u[n].message(t);
          break;

        case "finish":
          u[n].finish(n);
          break;

        case "close":
          u[n].close(n);
          break;

        case "open":
          if (!m) break;
          u[n].clickthrough(t);
          break;

        case "error":
          u[n].error(n);
      }
    }),
        c = m ? "&iframed.mraid=1" : "";
    w(n.window_url + s + c, e, i, r, o, a);
  }, r.prepareActivity = function (e) {
    t(e), i(e), y(), v(e);
  }, r.trackTriggerPointImpression = function (e) {
    b("clientjs");
  }, r.trackOptIn = function (e) {
    b("clientjs");
  }, r.trackOptOut = function (e) {
    b("clientjs");
  }, r.trackImpression = function (e) {
    var t = e && e.id ? e.id : "",
        n = e && e.campaign_id ? e.campaign_id : "",
        i = "network_user_id=" + c.network_user_id + "&partner_config_hash=" + c.partner_config_hash + "&campaign_id=" + n + "&creative_id=" + t + "&type=jsapiv4&d=" + new Date().getTime() + "&r=" + uniqueIdentifier();
    if (e.session_id) i += "&session_id=" + e.session_id;else {
      var r = RegExp("[?&]session_id=([^&]*)").exec(e.window_url);
      r && (i += "&session_id=" + decodeURIComponent(r[1].replace(/\+/g, " ")));
    }
    new Image().src = getLocationProtocol() + "//" + d + "/impression?" + i;
  };
  var s = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB]{1}[0-9A-F]{3}-[0-9A-F]{12}$/,
      l = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab]{1}[0-9a-f]{3}-[0-9a-f]{12}$/,
      p = !1,
      f = [];

  truex.loadExelateSegments = function () {
    var e,
        t,
        n = "//load.exelator.com/load/?p=104&g=700&j=j&t_cb=";
    /Android/.test(navigator.userAgent) && (t = c.network_user_id, l.test(t)) ? n = "//loadus.exelator.com/load?p=104&g=701&xl8Id=" + c.network_user_id + "&idtype=AAID&APP=1&j=j&t_cb=" : /iPhone|iPad|iPod|iOS/.test(navigator.userAgent) && (e = c.network_user_id, s.test(e)) && (n = "//loadus.exelator.com/load?p=104&g=701&xl8Id=" + c.network_user_id.toLowerCase() + "&idtype=IDFA&APP=1&j=j&t_cb=");
    var i = p = !!{}[c.partner_config_hash],
        r = [],
        o = "truex_exelate_callback";

    if (window[o] = function (e) {
      if (e && e.segments && e.segments.length) for (var t = 0; t < e.segments.length; t++) {
        f.push(e.segments[t]);
      }
      if (p) k("exelate", f);else {
        p = !0;

        for (t = 0; t < r.length; t++) {
          r[t]();
        }
      }
    }, !i) {
      var a = document.createElement("script");
      a.type = "text/javascript", a.async = !0, a.src = getLocationProtocol() + n + o, document.getElementsByTagName("head")[0].appendChild(a), setTimeout(function () {
        if (!p) {
          p = !0;

          for (var e = 0; e < r.length; e++) {
            r[e]();
          }
        }
      }, 500);
    }

    return function (e) {
      i || p ? e && e instanceof Function && e() : e && e instanceof Function && r.push(e);
    };
  }();

  var n = function n() {
    new Image().src = getLocationProtocol() + "//tags.bluekai.com/site/28311?id=" + c.network_user_id + "%3A" + c.partner_config_hash;
  },
      a = function a(e) {
    new Image().src = getLocationProtocol() + "//dpm.demdex.net/ibs:dpid=66013&dpuuid=" + e + "-" + c.network_user_id;
  },
      _ = function _(e) {
    new Image().src = "https://idsync.rlcdn.com/466426.gif?partner_uid=" + e + "-" + c.network_user_id;
  },
      g = function g(e) {
    new Image().src = "https://beacon.krxd.net/usermatch.gif?partner=truex&partner_uid=" + e + "-" + c.network_user_id;
  },
      h = function h(e) {
    new Image().src = "https://aa.agkn.com/adscores/g.pixel?sid=9212300858&puid=" + e + "-" + c.network_user_id;
  },
      t = function t(n) {
    u[n] = {
      start: noOp,
      message: noOp,
      credit: noOp,
      finish: noOp,
      clickthrough: noOp,
      close: noOp,
      error: noOp,
      partialCredit: noOp
    }, n.onStart = function (t) {
      u[n].start = function () {
        var e = Array.prototype.slice.call(arguments);
        t.apply(null, e), u[n].start = function () {};
      };
    }, n.onMessage = function (e) {
      u[n].message = e;
    }, n.onCredit = function (e) {
      u[n].credit = e;
    }, n.onFinish = function (e) {
      u[n].finish = e;
    }, n.onClose = function (e) {
      u[n].close = e;
    }, n.onError = function (e) {
      u[n].error = e;
    }, n.onClickthrough = function (e) {
      u[n].clickthrough = e;
    }, n.onPartialCredit = function (e) {
      u[n].partialCredit = e;
    };
  },
      i = function i(e) {
    e.trackTriggerPointShown = function () {}, e.trackUserOptedIn = function () {}, e.trackUserOptedOut = function () {};
  },
      w = function w(e, t, n, i, r, o) {
    var a = document.createElement("IFRAME");
    a.border = a.frameBorder = 0, a.allowTransparency = !0, a.src = "javascript:false", a.style.width = n, a.style.height = i, a.style.minWidth = r, a.style.minHeight = o, a.allow = "geolocation; microphone; camera; autoplay", "string" == typeof t && (t = document.getElementById(t)), (t = t || document.body).appendChild(a), a.src = e;
  },
      v = function v(e) {
    try {
      e.partner_id && delete e.partner_id;
    } catch (e) {}
  },
      x = function x(e) {
    var t = getLocationProtocol() + "//" + d + "/v2?";
    t += "ext.referrer=" + encodeURIComponent(window.location.href.substring(0, 500)), t += "&env[]=html";
    var n = {
      partner_config_hash: "placement.key",
      network_user_id: "user.uid",
      gender: "user.gender",
      age: "user.age",
      dimension_1: "dimension_1",
      dimension_2: "dimension_2",
      dimension_3: "dimension_3",
      dimension_4: "dimension_4",
      dimension_5: "dimension_5"
    };

    for (var i in e) {
      if (e.hasOwnProperty(i)) {
        var r = e[i];
        n[i] ? t += "&" + n[i] + "=" + encodeURIComponent(r) : !r || r instanceof Function || (t += "&ext." + i + "=" + encodeURIComponent(r));
      }
    }

    return 0 < f.length && (t += "&exelate_segment_ids=" + encodeURIComponent(f.join(","))), t;
  },
      y = function y(e) {
    try {
      window._qevents = window._qevents || [], function () {
        var e = document.createElement("script");
        e.src = ("https:" == getLocationProtocol() ? "https://secure" : "http://edge") + ".quantserve.com/quant.js", e.async = !0, e.type = "text/javascript";
        var t = document.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(e, t);
      }(), _qevents.push({
        qacct: "p-EzVU5HfAMVqEV",
        labels: "impression"
      });
    } catch (e) {}

    try {
      window._comscore = window._comscore || [], window._comscore.push({
        c1: "8",
        c2: "8030913",
        c3: "1"
      });
      var t = document.createElement("script"),
          n = document.getElementsByTagName("script")[0];
      t.async = !0, t.src = ("https:" == getLocationProtocol() ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js", n.parentNode.insertBefore(t, n);
    } catch (e) {}
  },
      k = function k(e, t) {
    if (t && 0 < t.length) {
      var n = getLocationProtocol() + "//" + d + "/placements/" + c.partner_config_hash + "/users/" + c.network_user_id,
          i = new XMLHttpRequest();
      i.open("POST", n, !0), i.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), i.send(e + "_segment_ids=" + t.join(","));
    }
  },
      b = function b(e, t, n, i) {
    var r = e && e.id ? e.id : "",
        o = e && e.campaign_id ? e.campaign_id : "",
        a = "network_user_id=" + c.network_user_id + "&placement_hash=" + c.partner_config_hash + "&campaign_id=" + o + "&creative_id=" + r + "&type=jsapiv4&d=" + new Date().getTime() + "&r=" + uniqueIdentifier();
    if (e.session_id) a += "&session_id=" + e.session_id;else {
      var s = RegExp("[?&]session_id=([^&]*)").exec(e.window_url);
      s && (a += "&session_id=" + decodeURIComponent(s[1].replace(/\+/g, " ")));
    }
    new Image().src = getLocationProtocol() + "//" + d + "/impression?" + a;
  };

  !function () {
    if (c.partner_config_hash || (c.partner_config_hash = c.placement_key), !c.partner_config_hash) throw {
      name: "Error",
      message: "partner_config_hash is required"
    };
    if (!c.network_user_id) throw {
      name: "Error",
      message: "network_user_id is required"
    };
    c.timezone_offset || (c.timezone_offset = new Date().getTimezoneOffset() / 60), c.initialized && c.initialized instanceof Function && c.initialized(), truex.xdm.ready ? e(r) : truex.xdm.onReady = function () {
      e(r);
    };
  }();
},
    client_1 = client,
    TruexAdClient = function TruexAdClient() {
  var e = domReady;
  window.truex = window.truex || {};
  var t = window.truex;
  t.xdm = xdm_1, e(function () {
    t.xdm.init();
  }), t.client = client_1;
},
    main = TruexAdClient;

module.exports = main;